<template lang='pug'>
  v-chip
    img.image(:src='getBrowser(environment.browser)')
    | {{environment.browser | browser}}
</template>

<script>
import EnvironmentMixin from '../mixins/environment.mixin';

export default {
  name: 'BionicMetricsEnvironment',
  components: {},
  props: ['environment'],
  methods: {},
  mixins: [EnvironmentMixin],
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .image {
    margin: 2px;
    height: 20px;
    width: 20px;
  }
</style>
